export const MIN_RECORDING_DURATION_MS = 500;
export const MAX_RECORDING_DURATION_MS = 120000;
/** Safari's AGC/noise-suppression calibration attenuates the first moment of audio
 * on a freshly opened track; delay the "ready to speak" signal past that window. */
export const RECORDING_WARMUP_MS = 350;

export function getRecordingMimeType(): string {
  if (typeof MediaRecorder !== 'undefined') {
    if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) return 'audio/webm';
    if (MediaRecorder.isTypeSupported('audio/mp4')) return 'audio/mp4';
    if (MediaRecorder.isTypeSupported('audio/ogg')) return 'audio/ogg';
  }
  return 'audio/webm';
}

export function getRecordingExtension(): string {
  const mime = getRecordingMimeType();
  if (mime.includes('mp4')) return 'mp4';
  if (mime.includes('ogg')) return 'ogg';
  return 'webm';
}

export async function getPermissionStatus(): Promise<boolean | null> {
  try {
    const result = await navigator.permissions.query({ name: 'microphone' as PermissionName });
    if (result.state === 'granted') return true;
    if (result.state === 'denied') return false;
    return null;
  } catch {
    return null;
  }
}
